module.exports = __webpack_public_path__ + "static/burke-logo-793eb981ed2e45095929bf271516c913.png";